import { ExclamationCircleIcon } from '@heroicons/react/solid';
import { ExclamationIcon } from '@heroicons/react/outline';
import React from 'react';

export function ErrorAnnouncement({
    title,
    list,
    noShadow,
    useTriangleIcon,
}: {
    title: string;
    list?: string[];
    noShadow?: boolean;
    useTriangleIcon?: boolean;
}) {
    return (
        <div className={`rounded-md bg-red-100 p-4 ${!noShadow && 'shadow-md'} mb-2`}>
            <div className="flex items-center">
                <div className="flex-shrink-0">
                    {useTriangleIcon ? (
                        <ExclamationIcon className="h-5 w-5 text-error-600" aria-hidden="true" />
                    ) : (
                        <ExclamationCircleIcon
                            className="h-5 w-5 text-error-600"
                            aria-hidden="true"
                        />
                    )}
                </div>
                <div className="ml-3">
                    <h3 className="text-base font-medium text-passport ">{title}</h3>
                    {list && (
                        <div className="mt-2 text-base text-gray-600">
                            <ul role="list" className="list-disc pl-5 space-y-1">
                                {list?.map((e) => {
                                    return <li key={e}>{e}</li>;
                                })}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
